@if (isUnEnabledForCurrentApp()) {
  <mat-toolbar class="un-toolbar" color="primary">
    @if (isShowingHomePageButton()) {
      @if (getLogoUrl() && !isMobile) {
        <button (click)="goToDistrictHomePage()" aria-label="Go to district sites page" class="return-to-district-btn">
          <img class="logo" [src]="getLogoUrl()" alt="Go to district sites page">
        </button>
      }
    } @else {
      @if (getLogoUrl() && !isMobile) {
        <img class="logo" [src]="getLogoUrl()" alt="Logo image for current location">
      }
    }
    <div [ngStyle]="{'display': toolbarPortal ? 'none': ''}" class="left">
      @if (isMenuToggleEnabled() && getMenuItems().length > 0) {
        <button
          class="desktop-sidenav-button"
          mat-icon-button
          (click)="toggleSidenav()"
          type="button"
          [attr.aria-label]="isSidenavOpen() ? 'Close menu' : 'Open menu'"
          [disabled]="isLoginPopupDisplayed"
          >
          <mat-icon [svgIcon]="isSidenavOpen() ? icons.CLOSE : icons.HAMBURGER_MENU"></mat-icon>
        </button>
      }
      @if (isShowingHomePageButton()) {
        @if (isDesktop && !getLogoUrl()) {
          <button aria-label="Go to district sites page" (click)="goToDistrictHomePage()" id="toolbar-district" class="districtName2-btn">{{districtName}}</button>
        }
      } @else {
        @if (isDesktop && !getLogoUrl()) {
          <div id="toolbar-district" class="districtName2">{{districtName}}</div>
        }
      }

      <div class="site-switcher-container">
        <fss-portal-site-switcher-menu></fss-portal-site-switcher-menu>
      </div>
    </div>

    <div [ngStyle]="{'display': toolbarPortal ? 'none': ''}" class="menu-actions">
      <ng-container>

        <!-- App Switcher -->
        @if (showAppSwitcher) {
          <fss-portal-app-switcher></fss-portal-app-switcher>
        }

        <!-- Notifications -->
        @if (showSiteNotifications) {
          <fss-portal-notification></fss-portal-notification>
        }

        <!-- User Profile -->
        @if (showUserProfile) {
          <fss-portal-user-profile></fss-portal-user-profile>
        }

        <!-- Guest Login -->
        @if (showLogin) {
          <button
            id="toolbar-guest-login-btn"
            (click)="login()"
            aria-label="Login"
            [disabled]="isLoginPopupDisplayed"
            class="un-guest-login-btn"
            [class.btn-hover]="!isDDorCollections()"
            >
            Log in
            @if (!isMobile) {
              <fa-icon class="login-icon" [icon]="['fal', 'circle-user']"></fa-icon>
            }
            @if (!isMobile) {
              <fa-icon class="login-icon-hover" [icon]="['fas', 'circle-user']"></fa-icon>
            }
          </button>
        }
      </ng-container>
    </div>

    @if (toolbarPortal) {
      <span style="width: 40px;">
        <!--this fake element ensures the flexbox positions the following name element in the center of the toolbar-->
      </span>
      <div>
        {{toolbarPortal.title}}
      </div>
      <button
        mat-icon-button
        (click)="closeSidenavPortal()"
        type="button"
        aria-label="Close mobile menu"
        >
        <mat-icon [svgIcon]="icons.CLOSE"></mat-icon>
      </button>
    }
  </mat-toolbar>
} @else {
  <!-- Sidenav is not enabled -->
  <!-- Sidenav is not enabled -->
  <!-- Sidenav is not enabled -->
  <mat-toolbar color="primary">
    <div class="left">
      <div id="site-banner" class="site-banner">

        <ng-container>
          @if (isThemeChangerEnabled || isMessageSenderEnabled || isSecretsEnabled) {
            <mat-icon class="menuIcon" [matMenuTriggerFor]="menuItems" [svgIcon]="icons.FOLLETT_LEARNING" aria-hidden="true" tabindex="-1"></mat-icon>
          } @else {
            <mat-icon class="menuIcon" [svgIcon]="icons.FOLLETT_LEARNING" aria-hidden="false" tabindex="-1"></mat-icon>
          }
        </ng-container>

        <div [matMenuTriggerFor]="isThemeChangerEnabled || isMessageSenderEnabled || isSecretsEnabled ? menuItems : null">
          <div class="destiny-text">Destiny</div>
          @if (siteGuid) {
            <div id="toolbar-school" class="district-name">{{ siteName }}</div>
          }
          @if (!siteGuid) {
            <div id="toolbar-district" class="district-name">{{ districtName }}</div>
          }
        </div>
      </div>
    </div>

    <mat-menu class="action-menu" #menuItems="matMenu" xPosition="before">
      @if (isThemeChangerEnabled) {
        <fss-portal-theme-picker></fss-portal-theme-picker>
      }

      @if (isMessageSenderEnabled) {
        <fss-portal-message-sender></fss-portal-message-sender>
      }

      @if (isSecretsEnabled) {
        <fss-portal-secret></fss-portal-secret>
      }
    </mat-menu>

    <nav class="app-menu-items">
      @if (isDesktop) {
        <fss-portal-view-type-select></fss-portal-view-type-select>
        @for (menu of getMenuItems(); track menu.id) {
          <fss-portal-menu [menu]="menu" inToolbar></fss-portal-menu>
        }
      }
    </nav>

    <div class="menu-actions">
      @if (!isMobile) {
        @if (showUserProfile && showSiteSwitcher()) {
          <fss-portal-site-switcher-menu></fss-portal-site-switcher-menu>
        }
        <!-- Notifications -->
        @if (showSiteNotifications) {
          <fss-portal-notification></fss-portal-notification>
        }
        <!-- User Profile -->
        @if (showUserProfile) {
          <fss-portal-user-profile></fss-portal-user-profile>
        }
        <!-- Guest Login -->
        @if (showLogin) {
          <div>
            <button id="toolbar-guest-login-btn" mat-icon-button (click)="login()" aria-label="Login"
              [disabled]="isLoginPopupDisplayed">
              <mat-icon [svgIcon]="icons.LOGIN" title="Login"></mat-icon>
            </button>
          </div>
        }
      }

      <!-- App Switcher -->
      @if (showAppSwitcher) {
        <fss-portal-app-switcher></fss-portal-app-switcher>
      }

      @if (showHamburguerMenu) {
        <button
          mat-icon-button
          (click)="toggleMobileMenu()"
          type="button"
          [attr.aria-label]="isMobileMenuOpen ? 'Close mobile menu' : 'Open mobile menu'"
          [disabled]="isLoginPopupDisplayed"
          >
          <mat-icon [svgIcon]="isMobileMenuOpen ? icons.CLOSE : icons.HAMBURGER_MENU"></mat-icon>
          @if (unreadCount > 0 && isMobile && !isMobileMenuOpen) {
            <span class="unread-count">{{ unreadCount }}</span>
          }
        </button>
      }
    </div>
  </mat-toolbar>
}
